import { render } from "./vsaleflow.vue?vue&type=template&id=50523b52&scoped=true"
import script from "./vsaleflow.vue?vue&type=script&lang=js"
export * from "./vsaleflow.vue?vue&type=script&lang=js"

import "./vsaleflow.vue?vue&type=style&index=0&id=50523b52&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50523b52"]])

export default __exports__